<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="floralVarietyNicknameForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                floralVarietyNicknameForm: () => import('../forms/FloralVarietyNicknameForm'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Floral Variety', value: 'floralVarietyId', table: 'floralVarieties', form: () => import('../forms/FloralVarietyForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    floralVarieties: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "floralVarietyId", direction: "ascending" },
                ],
                itemsField: 'floralVarietyNicknames',
                editPageName: 'floralVarietyNickname',
                apiMethod: 'FloralVarietyNicknames',
                claimName: 'FloralVarietyNicknames',
                formTitle: 'Floral Variety Nickname',
                excelTitle: 'Floral Variety Nicknames',
                hasEditPage: false,
            }
        },
    };
</script>
